 
import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function stringsReducer(state= initialState.strings, action){
	switch(action.type){
		case types.SET_STRINGS_SUCCESS:	
			return action.datos.strings;		
	
		default:
			return state;
	}
}